import React, { Component } from 'react';
import { compose, mapProps } from 'recompose';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { toFormattedLocalDate } from 'utils/dateTime/converter';
import { htmlToReact } from 'utils/functions';
import Answer from 'components/threepp/assessment/Answers/Answer';
import ParticipantPopover from 'components/threepp/assessment/Question/ParticipantPopover/ParticipantPopover';
import { showErrorMessage } from 'components/common/Alert/Alert';
import { isAssessmentReadOnly as isAssessmentReadOnlySelector } from 'selectors/assessment/selector';
// import { ActionsHOC }  from '../Actions/ActionsHOC'
import { ActionsHOC } from '../Actions/ActionsHOC';

import './Question.scss';

export class Question extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    isAssessmentReadOnly: PropTypes.bool,
    // TODO: Fix this...
    /* eslint-disable react/forbid-prop-types */
    question: PropTypes.object.isRequired,
    assessment: PropTypes.object.isRequired,
    /* eslint-enable react/forbid-prop-types */
    setAssigneesForField: PropTypes.func.isRequired,
    incrementAttachmentUploadCount: PropTypes.func.isRequired,
    decrementAttachmentUploadCount: PropTypes.func.isRequired
  };

  static defaultProps = {
    isAssessmentReadOnly: false
  };

  componentDidMount() {
    this.updateQuestionAssignees = _.debounce(this.updateQuestionAssignees, 2000);
  }

  updateQuestionAssignees = (addedParticipants, removedParticipants) => {
    const { question, assessment, setAssigneesForField: propsSetAssigneesForField, t } = this.props;
    const questionAssignees = question.assignees.map(a => a.email);

    // 1) Remove unselected users from the initial question assignees
    let newAssignees = _.without(questionAssignees, ...removedParticipants);
    // 2) Add selected users
    newAssignees = _.union(newAssignees, addedParticipants);

    propsSetAssigneesForField({
      variables: {
        assessmentId: assessment.id,
        fieldId: question.id,
        emails: newAssignees
      }
    }).catch(() => {
      showErrorMessage(t('assessment.questions.errorAssigningParticipant'));
    });
  };

  getCalculatedValues = question => {
    const { textValue, numericValue } = question;
    let { listValue } = question;
    const localTimeValue = question.dateValue ? toFormattedLocalDate(question.dateValue, 'YYYY-MM-DD') : '';

    if (listValue && listValue.length > 1) {
      listValue = listValue.map(value => ` ${value} `);
    }
    return textValue || numericValue || listValue || localTimeValue;
  };

  isCalculated = (displayText, question) => (
    <div className="calculated-prompt">
      <div className="calculated-label">{htmlToReact(displayText)}</div>
      <div className="calculated-text">{htmlToReact(this.getCalculatedValues(question))}</div>
    </div>
  );

  render() {
    const {
      question,
      assessment,
      isAssessmentReadOnly,
      incrementAttachmentUploadCount,
      decrementAttachmentUploadCount,
      fieldAclAction,
      categoryAclAction,
      invokeActionsForFields,
      t,
      fieldFvlAction,
      setDateAction,
      SVLAction,
      uploadingAttachment,
      setUploadingAttachment,
      questionId
    } = this.props;
    const { calculated, assignees, displayText, label } = question;
    return (
      fieldAclAction !== 'Hide' && (
        <div className={fieldAclAction === 'Hide' ? 'question-wrapper hide-question' : 'question-wrapper'}>
          {question.calculated ? (
            this.isCalculated(displayText || label, question)
          ) : (
            <React.Fragment>
              <div className="question-title">
                <div className="prompt">
                  <div className="label">
                    {(question.required === true || fieldAclAction === 'Required') && <span className="required">* </span>}
                    {question.label}
                  </div>
                </div>
                <div className="assignees">
                  <ParticipantPopover
                    disabled={isAssessmentReadOnly}
                    header={t('assessment.questions.assignmentTitle')}
                    assessmentParticipants={assessment.participants}
                    initialAssignees={assignees}
                    onAssigneesChanged={this.updateQuestionAssignees}
                    hideIfNoParticipants={false}
                  />
                </div>
              </div>
              <div className="answer">
                <div className="row no-gutters">
                  <div className="col-md-12">
                    <div className="answer-text" align="left">
                      {htmlToReact(displayText)}
                    </div>
                    <Answer
                      calculated={calculated}
                      assessmentId={assessment.id}
                      assessment={assessment}
                      question={question}
                      filterValues={fieldFvlAction}
                      setDateValue={setDateAction}
                      SVLAction={SVLAction}
                      invokeActionsForFields={invokeActionsForFields}
                      disabled={isAssessmentReadOnly || fieldAclAction === 'ReadOnly' || categoryAclAction === 'ReadOnly'}
                      incrementAttachmentUploadCount={incrementAttachmentUploadCount}
                      decrementAttachmentUploadCount={decrementAttachmentUploadCount}
                      setUploadingAttachment={setUploadingAttachment}
                      uploadingAttachment={uploadingAttachment}
                      questionId={questionId}
                    />
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      )
    );
  }
}

export const QuestionHOC = compose(
  withTranslation(),
  ActionsHOC,
  mapProps(props => ({
    t: props.t,
    question: props.question,
    assessment: props.assessment,
    actions: props.actions,
    invokeActionsForFields: props.invokeActionsForFields,
    categoryAclAction: props.categoryAclAction,
    fieldAclAction: props.aclAction,
    addAssignee: props.addAssignee,
    fieldFvlAction: props.fvlAction,
    setDateAction: props.setDateAction,
    SVLAction: props.SVLAction,
    setAssigneesForField: props.setAssigneesForField,
    isAssessmentReadOnly: isAssessmentReadOnlySelector(props),
    currentUser: props.currentUser,
    incrementAttachmentUploadCount: props.incrementAttachmentUploadCount,
    decrementAttachmentUploadCount: props.decrementAttachmentUploadCount,
    uploadingAttachment: props.uploadingAttachment,
    setUploadingAttachment: props.setUploadingAttachment,
    questionId: props.questionId
  }))
);

export default QuestionHOC(Question);
